/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Setting_Irl_DescInputs */



/**
* | output |
* | --- |
* | "Players are in the room, at real tables." |
*
* @param {Tournament_Wiz_Setting_Irl_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_setting_irl_desc = /** @type {((inputs?: Tournament_Wiz_Setting_Irl_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Setting_Irl_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les joueurs sont dans la salle, autour de vraies tables.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los jugadores están en la sala, en mesas reales.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os jogadores estão na sala, em mesas de verdade.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I giocatori sono in sala, a tavoli veri.")
	return /** @type {LocalizedString} */ ("Players are in the room, at real tables.")
});